import { createRouter, createWebHistory } from 'vue-router';
import Layout from '../components/layout/Layout.vue';
import HomePage from '../pages/HomePage.vue';
import AssetManagementPage from '../pages/AssetManagementPage.vue';
import VerificationPage from '../pages/VerificationPage.vue';
import RiskAnalysisPage from '../pages/RiskAnalysisPage.vue';

const routes = [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '',
        name: 'Home',
        component: HomePage,
        meta: { title: '하나은행' }
      },
      {
        path: 'asset-management',
        name: 'AssetManagement',
        component: AssetManagementPage,
        meta: { title: '자산운용사 종합 분석' }
      },
      {
        path: 'verification',
        name: 'Verification',
        component: VerificationPage,
        meta: { title: '투자상품설명서 사실 여부 검증' }
      },
      {
        path: 'risk-analysis',
        name: 'RiskAnalysis',
        component: RiskAnalysisPage,
        meta: { title: '투자대상기업 리스크 분석' }
      }
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
